import { MAX_RANGE, MIN_RANGE } from './Constants';

export function getPercentageSafe(numerator, denominator) {
  return numerator && denominator && Number.isInteger(numerator) && Number.isInteger(denominator)
    ? Math.round((numerator / denominator) * 100)
    : 0;
}

export function divideSafe(numerator, denominator) {
  return numerator && denominator && Number.isFinite(numerator) && Number.isFinite(denominator)
    ? numerator / denominator
    : 0;
}

export function checkIfInteger(evt) {
  if (!(evt.which === 8) && !(evt.which === 0) && (evt.which < 48 || evt.which > 57)) {
    evt.preventDefault();
  }
}

export function calculatePercentage(curr, prev) {
  if (curr === 0 && (prev === 0 || !Number.isInteger(prev))) {
    return 0;
  } else if (curr === 0 && prev > 0) {
    return -100;
  } else if (curr > 0 && (prev === 0 || !Number.isInteger(prev))) {
    return 100;
  } else {
    return Math.round(((curr - prev) / prev) * 100);
  }
}

export function isInRange(count, range = [MIN_RANGE, MAX_RANGE]) {
  return count !== null && count >= range[0] && count <= range[1];
}



// WEBPACK FOOTER //
// ./src/Utils/MathUtils.js